import GoodsTipsBG1 from '../../../../assets/images/goods-tips-bg1.png'

export const TIPS_STYLE = {
  width: 600,
  height: 750,
  borderRadius: 30
}
export const TIPS_PIC_BOX_STYLE = {
  width: '100%',
  height: 300,
  backgroundSrc: ''
}
export const TIPS_PIC_IMG_STYLE = {
  width: 200,
  height: 200
}
export const TIPS_DESC_TITLE_STYLE = {
  fontSize: 36,
  fontWeight: 600,
  color: '#000'
}
export const TIPS_DESC_CONTENT_STYLE = {
  fontSize: 24,
  fontWeight: 500,
  color: '#a9a9a9'
}

export const IMG_MAP = {
  1: GoodsTipsBG1
}
